import { IconSelectArrowDown } from 'assets/icons';

import { qnTexts } from '../themes/_palette';

export const MuiTablePagination = {
    styleOverrides: {
        root: {
            ".MuiTablePagination-actions > button": {
                "[dir=rtl] &": {
                    transform: 'scaleX(-1)'
                }
            },
            ".MuiTablePagination-actions": {
                display: 'none' // [GM]: hide actions arrows
            },
            ".MuiTablePagination-selectLabel, .MuiTablePagination-select, .MuiTablePagination-displayedRows": {
                color: qnTexts.placeholderDarker,
                fontSize: '12.8px',
                height: 20
            },
            "&& .MuiTablePagination-select": {
                paddingRight: '40px !important'
            }
        }
    },
    defaultProps: {
        SelectProps: { IconComponent: IconSelectArrowDown }
    }
}
